export function getValue(value, source_types) {
  if (Array.isArray(value) && value.length > 0) {
    return value
  }
  // select all
  return source_types.map(type => type.id)
}
